import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import Model from "@ckeditor/ckeditor5-ui/src/model"
import { createDropdown } from "@ckeditor/ckeditor5-ui/src/dropdown/utils"
import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview"
import Collection from "@ckeditor/ckeditor5-utils/src/collection"
import api from "../../honcierge-api"
import Vue from "vue"

import OptionListItemView from "./customcomponents/optionlistitemview"
import SelectView from "./customcomponents/selectview"
import View from "@ckeditor/ckeditor5-ui/src/view"
import store from "../../store"
export default class InlineAdvertisementUI extends Plugin {
  async init() {
    const editor = this.editor

    const role = store.state.adminUser.role

    if (role === "editor" || role === "administrator") {
      let templates = []
      try {
        const response = await api.getInlineAdvertisements(
          "",
          "",
          "",
          null,
          "id",
          true,
          1,
          10000000
        )
        templates = response.data.inlineAdvertisements
      } catch (_) {
        Vue.toasted.error("インライン広告マスタの取得に失敗しました")
        return
      }

      editor.ui.componentFactory.add("inlineAdvertisement", (locale) => {
        const itemDefinitions = new Collection()
        itemDefinitions.add(
          new Model({
            inlineAdvertisementId: -1,
            inlineAdvertisementDescription: "デフォルト",
          })
        )
        templates.forEach((template) => {
          itemDefinitions.add(
            new Model({
              inlineAdvertisementId: template.id,
              inlineAdvertisementDescription: template.description,
              withText: true,
            })
          )
        })
        const dropdownView = createDropdown(locale, SplitButtonView)
        dropdownView.buttonView.set({
          value: {},
          isOn: true,
          withText: true,
          label: "インライン広告",
        })
        dropdownView.buttonView.on("execute", () => {
          // コマンド実行
          editor.execute(
            "insertInlineAdvertisement",
            dropdownView.buttonView.value
          )
          editor.editing.view.focus()
        })
        this.addCustomListToDropdown(dropdownView, itemDefinitions)

        return dropdownView
      })
    }
  }

  addCustomListToDropdown(dropdownView, items) {
    const locale = dropdownView.locale
    const selectView = (dropdownView.listView = new SelectView(locale))

    // listView(selectタグ)のプロパティとdropdown.buttonViewのプロパティをbind
    // これは選択されたインライン広告をbindするためのもの
    dropdownView.buttonView.bind("value").to(selectView)

    selectView.items.bindTo(items).using((model) => {
      const optionView = new OptionListItemView(locale)
      const itemView = this._createItemView(
        model.inlineAdvertisementId,
        model.inlineAdvertisementDescription
      )
      optionView.children.add(itemView)

      return optionView
    })

    dropdownView.panelView.children.add(selectView)
    selectView.initFirst() // 初期化時に最初の要素を設定する
  }

  _createItemView(inlineAdvertisementId, inlineAdvertisementDescription) {
    const view = new View()

    view.set({ label: inlineAdvertisementDescription })

    view.setTemplate({
      tag: "div",
      attributes: {
        "inline-advertisement-id": inlineAdvertisementId,
        "inline-advertisement-description": inlineAdvertisementDescription,
      },
      children: [
        {
          text: view.bindTemplate.to("label"), // このlabelはメソッドの内で定義済みのobservableな'label'を指定
        },
      ],
    })

    return view
  }
}
